// Public website copy & commercial placeholders. Edit here — nothing else needs to change.
// Values in [BRACKETS] are intentionally unfilled: replace them before launch.
export const SITE = {
  brand: "Wappy",
  legalName: "[COMPANY LEGAL NAME]",
  city: "Ahmedabad",
  supportPhone: "[SUPPORT PHONE]",
  supportEmail: "[SUPPORT EMAIL]",
  trialDays: "[TRIAL LENGTH]",
  yearlySaving: "[X]",
  managedAddonPrice: "[₹ ADD-ON PRICE]",
  paymentGateway: "[YOUR PAYMENT GATEWAY]",
  setupFee: "[SETUP FEE OR FREE]",
  cancellationPolicy: "[YOUR UPGRADE, DOWNGRADE AND CANCELLATION POLICY]",
  integrations: "[YOUR INTEGRATIONS]",
  plans: [
    { id: "starter", name: "Starter", blurb: "For one business getting started on WhatsApp.", monthly: "₹[MONTHLY]", yearly: "₹[YEARLY]",
      items: ["1 WhatsApp number", "[N] team members", "Broadcasts and template library", "AI campaign planner: [N] plans a month", "Shared team inbox"] },
    { id: "growth", name: "Growth", blurb: "For teams running campaigns every week.", featured: true, monthly: "₹[MONTHLY]", yearly: "₹[YEARLY]",
      items: ["Everything in Starter", "No-code flow builder and drip sequences", "AI agents for replies", "Click-to-WhatsApp ads manager", "Campaign analytics and click tracking"] },
    { id: "scale", name: "Scale", blurb: "For multi-branch brands and high volumes.", monthly: "₹[MONTHLY]", yearly: "₹[YEARLY]",
      items: ["Everything in Growth", "Multiple numbers and brands", "API and webhooks", "AI trained on your catalogue and FAQs", "Priority support"] },
  ],
};
